import type { TMessages } from '@/types/TMessages'

export const messages = {
  agreements: {
    text: 'Нажатие на кнопку "Отправить" подтверждает ваше согласие на передачу данных, внесенных в форму заявки, а также ваших персональных данных (имя, отчество, e-mail), ИНН и названия организации в {link}',
    link: 'ООО МКК "Поле Инвест"',
    notLink: 'ООО "Деметра Трейдинг"',
  },
  field: {
    phone: {
      label: 'Введите ваш телефон',
    },
    name: {
      label: 'Желаемая сумма',
    },
    regions: {
      label: 'Укажите регион',
    },
    error: {
      requiredFieldPriceDefault: 'Введите желаемую сумму',
      requiredFieldPriceMFO: 'Введите желаемую сумму до 200 млн',
      requiredFieldPhone: 'Введите ваш номер',
      requiredMinPriceMFO: 'Введите сумму больше 0',
      requiredMinPrice: 'Минимальная сумма составляет 1 млн рублей. Измените желаемую сумму, чтобы отправить заявку.',
      requiredMaxPriceMFO: 'Максимальная сумма кредита - 200 млн руб',
      requiredMaxPrice: 'Введите сумму меньше 100 000 000 000 000',
      region: 'Укажите ваш регион',
      phone: 'Введите ваш телефон',
      required: 'Обязательное поле',
    },
  },
  form: {
    submit: 'Отправить заявку',
    agreement: {
      text: 'Даю {agreement} на обработку своих персональных данных в соответствии c {policy}',
      agreement: 'Согласие',
      policy: 'Политикой обработки персональных данных',
    },
  },
} satisfies TMessages
